import React from 'react';

import AiBotPillComponent from '../common/genericComponents/redesign/aiBotPillComponent/aiBotPillComponent';
import MentorPillComponent from '../common/genericComponents/redesign/mentorPillComponent/mentorPillComponent';

import './participantChatPillComponent.css';

const ParticipantChatPillComponent = ({
  assistantName,
  isOoniPill = false,
  isMentorSide = true,
  showMentorEmail = false,
  extendedMentorDto,
  widgetName,
}) => {
  return (
    <div className="et-v2-participant-chat-pill-container">
      {isOoniPill ? (
        <AiBotPillComponent
          assistantName={assistantName}
          widgetName={widgetName}
        />
      ) : extendedMentorDto ? (
        <div
          className={`et-v2-pcpc-mentor-wrap ${!isMentorSide ? 'et-v2-pcpc-mentor-wrap-no-cursor' : ''}`}>
          <MentorPillComponent
            showMentorEmail={showMentorEmail}
            hideToolTip={!isMentorSide}
            isMentorSide={isMentorSide}
            extendedMentorDto={extendedMentorDto}
            widgetName={widgetName}
          />
        </div>
      ) : (
        <div className="et-v2-pcpc-guest-wrap">
          <MentorPillComponent
            hideToolTip
            isMentorSide={isMentorSide}
            icon={<i className="fas fa-user fa-lg" />}
          />
        </div>
      )}
    </div>
  );
};

export default ParticipantChatPillComponent;
